var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFulfillment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2763_14152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3409 25.5355C29.0205 26.1056 28.5899 26.6062 28.0741 27.0081C27.5583 27.4101 26.9677 27.7054 26.3366 27.8768C25.7056 28.0482 25.0467 28.0922 24.3984 28.0064C23.7502 27.9206 23.1255 27.7066 22.5607 27.3769C21.4164 26.6993 20.5844 25.5988 20.2445 24.313C19.9045 23.0273 20.0839 21.6594 20.7438 20.5047C21.1747 19.7463 21.7992 19.1158 22.5535 18.6775C23.3078 18.2393 24.1648 18.0092 25.0372 18.0105C25.0616 17.7169 25.1094 17.4289 25.1094 17.1306C25.1157 15.757 24.8448 14.3963 24.3129 13.1299C23.7811 11.8635 22.9991 10.7175 22.0139 9.76037L24.0776 7.58691C25.3543 8.82567 26.3676 10.3095 27.0569 11.9495C27.7461 13.5894 28.097 15.3517 28.0886 17.1306C28.0853 17.7483 28.0402 18.3651 27.9535 18.9767C28.9461 19.7117 29.6352 20.7847 29.8908 21.993C30.1464 23.2014 29.9508 24.4615 29.3409 25.5355Z",
    fill: "url(#paint0_linear_2763_14152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92333 23.0003C9.92695 22.119 9.70058 21.252 9.26659 20.485C8.94694 19.914 8.51677 19.4133 8.00118 19.0103C7.48559 18.6073 6.89491 18.311 6.26359 18.1387C5.63227 17.9664 4.97297 17.9216 4.32414 18.0068C3.67532 18.0921 3.04996 18.3057 2.48457 18.6352C1.34021 19.3128 0.508246 20.4133 0.168294 21.699C-0.171657 22.9848 0.00768125 24.3526 0.667589 25.5073C1.27075 26.5764 2.25217 27.3811 3.41874 27.763C4.58532 28.1449 5.85259 28.0764 6.97121 27.571C9.25737 29.3845 12.0874 30.3758 15.0055 30.3851C16.3284 30.3852 17.6434 30.1811 18.904 29.7801L18.0082 26.8984C17.0379 27.2093 16.0253 27.3675 15.0065 27.3674C12.9406 27.3577 10.9284 26.7089 9.24596 25.5101C9.68623 24.7467 9.91971 23.8816 9.92333 23.0003Z",
    fill: "url(#paint1_linear_2763_14152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5097 9.72176C13.2654 10.1714 14.1275 10.4107 15.0069 10.4151C15.9615 10.4168 16.8963 10.1428 17.6989 9.62605C18.5016 9.10931 19.138 8.37182 19.5317 7.50216C19.9254 6.63251 20.0597 5.66767 19.9183 4.72357C19.777 3.77947 19.3661 2.89625 18.735 2.18002C18.1038 1.46379 17.2794 0.944999 16.3606 0.685979C15.4418 0.42696 14.4677 0.438725 13.5554 0.71986C12.6431 1.001 11.8314 1.53955 11.2178 2.27081C10.6042 3.00208 10.2147 3.89497 10.0962 4.84221C8.13647 5.64452 6.40018 6.90953 5.03583 8.52906C3.67147 10.1486 2.71964 12.0745 2.26172 14.142L5.16307 14.8183C5.4974 13.3129 6.17065 11.9035 7.13164 10.6973C8.09262 9.49123 9.31601 8.52017 10.7088 7.85802C11.1322 8.6287 11.754 9.27216 12.5097 9.72176Z",
    fill: "url(#paint2_linear_2763_14152)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2763_14152",
    x1: 25,
    y1: 25.5,
    x2: 16.5625,
    y2: 18.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2763_14152",
    x1: 3,
    y1: 22,
    x2: 18,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2763_14152",
    x1: 18,
    y1: 3.5,
    x2: 6.17704,
    y2: 16.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2763_14152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfillment);
export default "https://cdn.d2cgo.com/dtc_center/v19/so_assets/static/media/fulfillment.abbc7abcc1c24755cc7fa0eabe75e2f9.svg";
export { ForwardRef as ReactComponent };